/**
 * Select Component Tokens
 *
 * Design tokens for PrimeNG 18 Select (dropdown) component.
 * Maps to Figma DS Select states: Standard, Hover, Focused, Disabled, Error, Active, Filled.
 * Uses semantic token references only; light/dark is resolved by semantic tokens.
 */
export const selectTokens = {
  select: {
    root: {
      background: '{formField.background}',
      disabledBackground: '{formField.disabledBackground}',
      filledBackground: '{formField.filledBackground}',
      filledHoverBackground: '{formField.filledHoverBackground}',
      filledFocusBackground: '{formField.filledFocusBackground}',
      borderColor: '{formField.borderColor}',
      hoverBorderColor: '{formField.hoverBorderColor}',
      focusBorderColor: '{formField.focusBorderColor}',
      invalidBorderColor: '{formField.invalidBorderColor}',
      color: '{formField.color}',
      disabledColor: '{formField.disabledColor}',
      placeholderColor: '{formField.placeholderColor}',
      invalidPlaceholderColor: '{formField.invalidPlaceholderColor}',
      shadow: 'none',
      borderRadius: '{borderRadius.sm}',
      paddingX: '0.75rem',
      paddingY: '0.25rem',
      transitionDuration: '{transition.duration}',
      focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
      }
    },

    dropdown: {
      width: '2.5rem',
      color: '{primary.color}'
    },

    overlay: {
      background: '{overlay.select.background}',
      borderColor: '{overlay.select.borderColor}',
      borderRadius: '{borderRadius.sm}',
      color: '{overlay.select.color}',
      shadow: '0 4px 18px 0 rgba(53, 67, 88, 0.08)'
    },

    list: {
      padding: '0.5rem',
      gap: '0.125rem'
    },

    option: {
      color: '{surface.1000}',
      focusColor: '{surface.1000}',
      focusBackground: '{surface.300}',
      selectedBackground: '{highlight.background}',
      selectedFocusBackground: '{highlight.background}',
      selectedColor: '{surface.1000}',
      selectedFocusColor: '{surface.1000}',
      padding: '0.4375rem 0.75rem',
      borderRadius: '{borderRadius.sm}'
    },

    optionGroup: {
      color: '{formField.color}',
      padding: '0.25rem 0.75rem'
    }
  }
};

export type SelectTokens = typeof selectTokens;
